module.exports = __webpack_public_path__ + "static/media/Portrait-10069.5d0104a9.jpg";